// extracted by mini-css-extract-plugin
module.exports = {"content":"content__22jAvalCzZH8"};